import { flexRowCenterCenter } from '../../../../common/styles/flex';
import { SITE_VARIABLES } from '../../../../common/styles/variables';
import { DISCOVERY_SHOW_NEXT_VIDEO_IN_TOTAL_SECONDS } from '../../discoveryPlugin.constants';

interface StylesObject {
  keepWatchingButtonsContainerStyle: { [key: string]: any };
  stayButtonStyle: { [key: string]: any };
  playNextButtonStyle: { [key: string]: any };
  stayTextStyle: { [key: string]: any };
  playNextTextStyle: { [key: string]: any };
  playNextFillButtonStyle: { [key: string]: any };
}

const titleFontFamily = SITE_VARIABLES.TEXT_FONT_FAMILY.LATO;

const keepWatchingButtonsContainer = {
  ...flexRowCenterCenter,
  width: '100%',
  height: '100%',
};

const button = {
  ...flexRowCenterCenter,
  position: 'relative',
  pointerEvents: 'auto',
  cursor: 'pointer',
  width: '70px',
  height: '28px',
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.TINY,
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
};

const stayButton = {
  ...button,
  marginRight: '16px',
  backgroundImage: 'linear-gradient(to right, #4f7dff 0%, #6348df 100%)',
};

const playNextButton = {
  ...button,
  backgroundColor: 'rgba(255, 255, 255, 0.46)',
};

const text = {
  fontFamily: titleFontFamily,
  fontWeight: '400',
  fontSize: '12px',
};

const stayText = {
  ...text,
  color: SITE_VARIABLES.COLORS.WHITE,
};

const playNextText = {
  ...text,
  color: SITE_VARIABLES.COLORS.BLACK,
  zIndex: '1',
};

const getPlayNextFillButton = (countdownTime: number): { [key: string]: any } => ({
  width: `${(countdownTime / DISCOVERY_SHOW_NEXT_VIDEO_IN_TOTAL_SECONDS) * 100}%`,
  height: '28px',
  left: '0',
  transition: 'width 0.25s linear',
  position: 'absolute',
  backgroundColor: SITE_VARIABLES.COLORS.WHITE,
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.TINY,
});

export const getKeepWatchingButtonsStyleObject = (countdownTime: number): StylesObject => {
  const playNextFillButton = getPlayNextFillButton(countdownTime);
  return ({
    keepWatchingButtonsContainerStyle: {
      ...keepWatchingButtonsContainer,
    },
    stayButtonStyle: {
      ...stayButton,
    },
    playNextButtonStyle: {
      ...playNextButton,
    },
    stayTextStyle: {
      ...stayText,
    },
    playNextTextStyle: {
      ...playNextText,
    },
    playNextFillButtonStyle: {
      ...playNextFillButton,
    },
  });
};
